export enum CsrdComplianceStatus {
  COMPLIANT = "COMPLIANT",
  NON_COMPLIANT = "NON_COMPLIANT",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  NOT_SUPPORTED = "NOT_SUPPORTED",
}

export const mapCsrdComplianceStatus = (status?: string | boolean): CsrdComplianceStatus => {
  if (status === undefined) {
    return CsrdComplianceStatus.NOT_APPLICABLE;
  }
  if (typeof status === "boolean") {
    return status ? CsrdComplianceStatus.COMPLIANT : CsrdComplianceStatus.NON_COMPLIANT;
  }
  switch (status) {
    case "COMPLIANT":
      return CsrdComplianceStatus.COMPLIANT;
    case "NON_COMPLIANT":
      return CsrdComplianceStatus.NON_COMPLIANT;
    case "NOT_APPLICABLE":
      return CsrdComplianceStatus.NOT_APPLICABLE;
    case "NOT_SUPPORTED":
      return CsrdComplianceStatus.NOT_SUPPORTED;
    default:
      return CsrdComplianceStatus.NOT_APPLICABLE;
  }
};
